import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { useConfiguration } from '../../../../context/configurationContext';

import { FormattedMessage } from '../../../../util/reactIntl';
import { getCountryFlagById } from '../../../../util/getCountryFlag';
import { languagesHelper as language } from '../../../../util/languages';
import { useIntl } from '../../../../util/reactIntl';

import { IconArrowHead } from '../../../../components';

import css from './CustomFullMobileMenu.module.css';

const CustomFullMobileMenu = props => {
  const { menuLinks, onLandscapesSection, rewildingLandscapesSection, listingsByFilters } = props;
  const intl = useIntl();

  const [accordionState, setAccordionState] = useState({
    isOpenDestinations: false,
    isOpenLandscapes: false,
    isOpenTourism: false,
    isOpenAbout: false,
  });

  const config = useConfiguration();
  const locale = language.get();

  useEffect(() => {
    if (Object.keys(rewildingLandscapesSection).length === 0) {
      onLandscapesSection(locale);
    }
  }, [rewildingLandscapesSection]);

  const { listing } = config;
  const { listingFields } = listing;
  const countries =
    listingFields.find(item => item.key === 'linstingFieldId_country')?.enumOptions || [];

  const tourismLinks = menuLinks.filter(
    item => item.href === '/p/what-is-rewilding' || item.href === '/p/rewilding_tourism' || item.href === '/p/ecotourism' || item.href === '/p/wolf-watching-trips'
  );

  const aboutLinks = menuLinks.filter(
    item => item.href !== '/p/what-is-rewilding' && item.href !== '/p/rewilding_tourism' && item.href !== '/p/ecotourism' && item.href !== '/p/wolf-watching-trips'
  );

  const onChangeAccordionState = (key, value) => {
    const newAccordionState = {};
    for (const entry of Object.entries(accordionState)) {
      if (entry[0] === key) {
        newAccordionState[entry[0]] = value;
      } else {
        newAccordionState[entry[0]] = false;
      }
    }
    setAccordionState(newAccordionState);
  };

  const linstingFieldId_country = listingsByFilters?.linstingFieldId_country || {};
  const showCountries = countries.map(item => {
    const count = linstingFieldId_country?.[item.option];

    // Missing counts (other pages before fetch) must not fall through — `undefined < 1` is false.
    if (!(count > 0)) return null;

    return (
      <li key={item.option}>
        <a className={css.link} href={`/s?pub_linstingFieldId_country=${item.option}`}>
          <span className={css.flag}>{getCountryFlagById(item.option)}</span>
          {language.labelsTranslator(item.option, intl)}
        </a>
      </li>
    );
  });

  const showLandscapes =
    rewildingLandscapesSection.blocks && rewildingLandscapesSection.blocks.length > 0
      ? rewildingLandscapesSection.blocks.map((item, index) => {
        return (
          <li key={`${item.blockName}-${index}`}>
            <a className={css.link} href={item?.media?.link?.href || item?.callToAction?.href}>
              {intl.formatMessage({ id: `TopbarLink.${item.blockId}` })}
            </a>
          </li>
        );
      })
      : null;

  const showTourism = tourismLinks.map((item, index) => {
    return (
      <li key={`${item.href}-${index}`}>
        <a className={css.link} href={item.href}>
          {intl.formatMessage({ id: `TopbarLink.${item?.route?.params?.pageId}` })}
        </a>
      </li>
    );
  });

  const showAbout = aboutLinks.map((item, index) => {
    return (
      <li key={`${item.href}-${index}`}>
        <a className={css.link} href={item.href}>
          {intl.formatMessage({
            id: `TopbarLink.${item?.route?.params?.pageId || item?.route?.name}`,
          })}
        </a>
      </li>
    );
  });

  const arrowIconDestinations = classNames(css.arrowIcon, {
    [css.arrowIconReversed]: accordionState.isOpenDestinations,
  });
  const linksDestinations = classNames(css.links, {
    [css.linksOpen]: accordionState.isOpenDestinations,
  });
  const arrowIconLandscapes = classNames(css.arrowIcon, {
    [css.arrowIconReversed]: accordionState.isOpenLandscapes,
  });
  const linksLandscapes = classNames(css.links, {
    [css.linksOpen]: accordionState.isOpenLandscapes,
  });
  const arrowIconTourism = classNames(css.arrowIcon, {
    [css.arrowIconReversed]: accordionState.isOpenTourism,
  });
  const linksTourism = classNames(css.links, {
    [css.linksOpen]: accordionState.isOpenTourism,
  });
  const arrowIconAbout = classNames(css.arrowIcon, {
    [css.arrowIconReversed]: accordionState.isOpenAbout,
  });
  const linksAbout = classNames(css.links, {
    [css.linksOpen]: accordionState.isOpenAbout,
  });

  return (
    <div className={css.wrapper}>
      <div className={css.block}>
        <button
          className={css.handlerButton}
          onClick={() =>
            onChangeAccordionState('isOpenDestinations', !accordionState.isOpenDestinations)
          }
        >
          <FormattedMessage id="TopbarDesktop.LinksMenu.destinations" />
          <span className={arrowIconDestinations}>
            <IconArrowHead direction="down" size="small" />
          </span>
        </button>
        <ul className={linksDestinations}>{showCountries}</ul>
      </div>
      <div className={css.block}>
        <button
          className={css.handlerButton}
          onClick={() =>
            onChangeAccordionState('isOpenLandscapes', !accordionState.isOpenLandscapes)
          }
        >
          <FormattedMessage id="TopbarDesktop.LinksMenu.landscapes" />
          <span className={arrowIconLandscapes}>
            <IconArrowHead direction="down" size="small" />
          </span>
        </button>
        <ul className={linksLandscapes}>{showLandscapes}</ul>
      </div>
      <div className={css.block}>
        <button
          className={css.handlerButton}
          onClick={() => onChangeAccordionState('isOpenTourism', !accordionState.isOpenTourism)}
        >
          <FormattedMessage id="TopbarDesktop.LinksMenu.tourism" />
          <span className={arrowIconTourism}>
            <IconArrowHead direction="down" size="small" />
          </span>
        </button>
        <ul className={linksTourism}>{showTourism}</ul>
      </div>
      <div className={css.block}>
        <button
          className={css.handlerButton}
          onClick={() => onChangeAccordionState('isOpenAbout', !accordionState.isOpenAbout)}
        >
          <FormattedMessage id="TopbarDesktop.LinksMenu.about" />
          <span className={arrowIconAbout}>
            <IconArrowHead direction="down" size="small" />
          </span>
        </button>
        <ul className={linksAbout}>{showAbout}</ul>
      </div>
    </div>
  );
};

export default CustomFullMobileMenu;
